export const getClientId = (id) => {
  // Pad the id with zeros to make it 3 digits
  const paddedId = id?.toString()?.padStart(3, "0");
  return `CLI-${paddedId}`;
};
export const getVendorId = (id) => {
  // Pad the id with zeros to make it 3 digits
  const paddedId = id?.toString()?.padStart(3, "0");
  return `VEN-${paddedId}`;
};
